"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const NativeSelect_1 = __importDefault(require("../../../common/js/atoms/NativeSelect"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const array_1 = require("../../../common/js/helper/array");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const AddToCartButton_1 = __importDefault(require("../../atoms/AddToCartButton"));
const NumberStepper_1 = __importDefault(require("../../atoms/NumberStepper"));
const ProductPrice_1 = __importDefault(require("../../atoms/ProductPrice"));
const Radio_1 = __importDefault(require("../../atoms/Radio"));
const Paths_1 = require("../../constants/Paths");
const Categories_1 = __importDefault(require("../../enums/Categories"));
const ProductSalesChannelId_1 = __importDefault(require("../../enums/ProductSalesChannelId"));
const ProductType_1 = __importDefault(require("../../enums/ProductType"));
const PropertyGroupExternalIds_1 = __importDefault(require("../../enums/PropertyGroupExternalIds"));
const history_1 = require("../../helper/history");
const media_1 = require("../../helper/media");
const money_1 = require("../../helper/money");
const path_1 = require("../../helper/path");
const product_1 = require("../../helper/product");
const ShopwareCategories_1 = __importDefault(require("../../stores/ShopwareCategories"));
const ShopwareProducts_1 = __importDefault(require("../../stores/ShopwareProducts"));
const UiStore_1 = __importDefault(require("../../stores/UiStore"));
const InfoBox_1 = __importDefault(require("../InfoBox"));
const ProductCardTile_1 = __importDefault(require("../ProductCardTile"));
const ShopProductMachineSelection_1 = __importDefault(require("./ShopProductMachineSelection"));
class ShopProduct extends react_1.default.Component {
    onRefreshDeferredPrices = null;
    contextReactionDisposer;
    additionalSeatProduct;
    additionalUserQuantity = 0;
    cachedCrossSellingProducts = new Map();
    cachedVariants = new Map();
    configurator;
    loading = false;
    product;
    selectedQuantity = 1;
    selectedMachineIds = [];
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            additionalSeatProduct: mobx_1.observable,
            additionalUserQuantity: mobx_1.observable,
            cachedCrossSellingProducts: mobx_1.observable,
            cachedVariants: mobx_1.observable,
            configurator: mobx_1.observable,
            loading: mobx_1.observable,
            product: mobx_1.observable,
            selectedQuantity: mobx_1.observable,
            selectedMachineIds: mobx_1.observable,
            crossSellingProducts: mobx_1.computed,
            variants: mobx_1.computed,
            productNumber: mobx_1.computed,
            backToOverviewPath: mobx_1.computed,
            productMedia: mobx_1.computed,
            minQuantity: mobx_1.computed,
            quantityOptions: mobx_1.computed,
            showQuantityOptions: mobx_1.computed,
            maxQuantity: mobx_1.computed,
            categoryIsSoftware: mobx_1.computed,
            customFields: mobx_1.computed,
            computedSoftwareLicense: mobx_1.computed,
            hideInfoBox: mobx_1.computed,
            softwareLink: mobx_1.computed,
            disableAddToCartButton: mobx_1.computed,
            hasSoftwareFooterContent: mobx_1.computed,
            hasAdditionalSeat: mobx_1.computed,
            hasVariants: mobx_1.computed,
            priceProduct: mobx_1.computed,
            hasRequiredMachinesSelected: mobx_1.computed,
            loadProduct: mobx_1.action.bound,
        });
    }
    get crossSellingProducts() {
        return Array.from(this.cachedCrossSellingProducts.values());
    }
    get variants() {
        return Array.from(this.cachedVariants.values());
    }
    get productNumber() {
        return this.props.match.params.product ?? null;
    }
    get backToOverviewPath() {
        if (!this.product?.extensions?.massiveCategoryTree?.ids?.length) {
            return Paths_1.PATH_SHOP;
        }
        const categories = this.validCategories;
        const software = categories.filter((categoryId) => this.isCategorySoftware(ShopwareCategories_1.default.getCategory(categoryId) ?? null));
        if (software.length > 0) {
            return `${Paths_1.PATH_SHOP}/${software.join('/')}`;
        }
        return `${Paths_1.PATH_SHOP}/${categories.join('/')}${this.props.location.state?.prevSearch ?? ''}`;
    }
    get validCategories() {
        const [, ...categories] = this.product?.extensions?.massiveCategoryTree?.ids ?? [];
        return categories.filter((category) => !Object.values(ProductSalesChannelId_1.default).some((salesCategory) => salesCategory === category));
    }
    get productMedia() {
        if (!this.product) {
            return [];
        }
        const { cover, media } = this.product;
        if (!media) {
            return [];
        }
        return media
            .filter((productMedia) => productMedia.mediaId !== cover?.mediaId)
            .map((productMedia) => productMedia.media)
            .filter((item) => !!item);
    }
    get minQuantity() {
        return this.product ? (0, product_1.getMinPurchase)(this.product) : 1;
    }
    get quantityOptions() {
        return this.product ? (0, product_1.getQuantityOptions)(this.minQuantity, this.product) : {};
    }
    get showQuantityOptions() {
        return this.product ? (this.product.purchaseSteps ?? 1) > 1 : false;
    }
    get maxQuantity() {
        return this.product ? (0, product_1.getMaxPurchase)(this.product) : 100;
    }
    get categoryIsSoftware() {
        const categories = this.product?.categories;
        if (!categories) {
            return false;
        }
        return (categories.filter((category) => {
            return category?.extensions?.massiveCategory?.externalId === Categories_1.default.SOFTWARE;
        }).length > 0);
    }
    get customFields() {
        return this.product?.translated?.customFields ?? null;
    }
    get computedSoftwareLicense() {
        return this.product?.extensions?.massiveComputedSoftwareLicense ?? null;
    }
    get hideInfoBox() {
        if (!this.computedSoftwareLicense?.licenseId) {
            return true;
        }
        return (ecommerce_1.MassiveComputedSoftwareLicenseStatusEnum.AlreadyBought === this.computedSoftwareLicense.status &&
            this.computedSoftwareLicense.productType === ProductType_1.default.ZUND_CONNECT);
    }
    get softwareLink() {
        const licenseId = this.computedSoftwareLicense?.licenseId;
        const path = licenseId ? Paths_1.PATH_ASSETS_SOFTWARE_EXPANDED.replace(':softwareId', licenseId) : Paths_1.PATH_ASSETS_SOFTWARE;
        return (0, path_1.localePath)(path);
    }
    get disableAddToCartButton() {
        return (this.computedSoftwareLicense?.status === ecommerce_1.MassiveComputedSoftwareLicenseStatusEnum.NotActivated ||
            this.loading ||
            !this.hasRequiredMachinesSelected);
    }
    get hasSoftwareFooterContent() {
        return (!!this.customFields?.massiveSoftwareConfigurationDescription ||
            !!this.customFields?.massiveSoftwareConfigurationCompareTable ||
            !!this.customFields?.massiveSoftwareConfigurationUrlReadMore);
    }
    get hasAdditionalSeat() {
        return this.categoryIsSoftware && !!this.additionalSeatProduct;
    }
    get hasVariants() {
        return this.variants.length > 0;
    }
    get priceProduct() {
        const additionalUnitPrice = this.hasAdditionalSeat && !!this.additionalSeatProduct && this.additionalUserQuantity > 0
            ? (0, money_1.unitPriceFromProduct)(this.additionalSeatProduct, { quantity: this.additionalUserQuantity }) *
                this.additionalUserQuantity
            : 0;
        const classPriceProductTitle = (0, classnames_1.default)('znd-shop-product-page__product-price', 'znd-shop-product-page__product-quantity-title', 't-body-small', 'font-weight-bold', { 'znd-shop-product-page__variant-option': this.hasVariants });
        return this.product ? (react_1.default.createElement(ProductPrice_1.default, { product: this.product, priceOptions: {
                quantity: this.selectedQuantity ?? 1,
                isPricePerYear: this.categoryIsSoftware,
                additionalUnitPrice: additionalUnitPrice,
                multiplyBy: this.selectedMachineIds.length > 0 ? this.selectedMachineIds.length : 1,
                showPriceLabel: true,
                classNamePriceLabel: classPriceProductTitle,
            }, onlyIndividualPrice: (0, product_1.showBulkPrices)(this.categoryIsSoftware, this.product) })) : null;
    }
    get hasRequiredMachinesSelected() {
        if (this.customFields?.zkpSoftwareRequiresMachineSelection && this.selectedMachineIds.length === 0) {
            return false;
        }
        return true;
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('shop_subpage_title', { title: this.product?.translated?.name });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => [
            AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.SHOP_READ),
            AuthorizationStore_1.default.auth0?.isLoading,
            this.productNumber,
            AuthorizationStore_1.default.customerId,
        ], ([hasAccess, authIsLoading, productNumber]) => {
            if (!authIsLoading && (!AuthorizationStore_1.default.auth0?.isAuthenticated || hasAccess) && productNumber) {
                this.loading = true;
                ShopwareCategories_1.default.initialize().then(() => {
                    this.loadProduct();
                    this.reloadProduct();
                });
            }
        }, { fireImmediately: true });
    }
    componentDidUpdate() {
        document.title = (0, translation_1.t)('shop_subpage_title', { title: this.product?.translated?.name });
        const setQuantity = this.product &&
            this.showQuantityOptions &&
            this.quantityOptions &&
            !this.quantityOptions[this.selectedQuantity];
        if (setQuantity) {
            this.selectedQuantity = this.minQuantity;
        }
    }
    componentWillUnmount() {
        const disposer = this.onRefreshDeferredPrices;
        if (null !== disposer) {
            disposer();
            this.onRefreshDeferredPrices = null;
        }
        this.contextReactionDisposer?.();
    }
    render() {
        const [productImage = this.product?.cover?.media] = this.productMedia;
        const maintainedDescriptionText = this.product?.translated?.description;
        if (!this.product) {
            return (react_1.default.createElement("section", { className: "znd-shop-product-page" },
                react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                    react_1.default.createElement(LoadingSpinner_1.default, null))));
        }
        return (react_1.default.createElement("section", { className: "znd-shop-product-page" },
            react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(this.backToOverviewPath) },
                react_1.default.createElement(Button_1.default, { className: "znd-shop-product-page__back-button", variant: ButtonVariant_1.default.text, iconLeft: Zupicons_1.default.arrowLeft, text: (0, translation_1.t)('product_page.back') })),
            !!this.computedSoftwareLicense && !this.hideInfoBox ? (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.LICENSE_READ] },
                react_1.default.createElement(InfoBox_1.default, { title: (0, translation_1.t)('product_page.info_box.software_status.title', {
                        status: this.computedSoftwareLicense.status,
                        licenseCount: this.computedSoftwareLicense.licenseCount,
                    }), innerHtml: (0, translation_1.t)('product_page.info_box.software_status.text', {
                        status: this.computedSoftwareLicense.status,
                        productName: this.product.translated?.customFields
                            ?.massiveSoftwareConfigurationTitleInProductList ??
                            this.product.translated?.name,
                        licenseCount: this.computedSoftwareLicense.licenseCount,
                    }), link: react_1.default.createElement("a", { href: this.softwareLink, className: "znd-info-box__link t-body-small" },
                        (0, translation_1.t)('product_page.info_box.software_status.link', {
                            status: this.computedSoftwareLicense.status,
                        }),
                        react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.arrowRight })) }))) : null,
            react_1.default.createElement("section", { className: (0, classnames_1.default)('znd-shop-product-page__content', {
                    '--no-margin': !!this.computedSoftwareLicense?.status,
                }) },
                react_1.default.createElement("header", { className: "znd-shop-product-page__top" },
                    productImage ? (react_1.default.createElement("div", { className: "znd-shop-product-page__image-wrapper" },
                        react_1.default.createElement("img", { ...(0, media_1.imageSourceFromMedia)(productImage), alt: productImage.alt, className: "znd-shop-product-page__image" }))) : null,
                    react_1.default.createElement("section", { className: "znd-shop-product-page__info" },
                        react_1.default.createElement("h1", { className: "znd-shop-product-page__title t-headline-1" }, this.product.translated?.name),
                        maintainedDescriptionText && (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-shop-product-page__product-description', 't-body', {
                                'mb-5': this.categoryIsSoftware,
                            }), dangerouslySetInnerHTML: { __html: maintainedDescriptionText } })),
                        !!this.customFields?.zkpSoftwareRequiresMachineSelection ? (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.MACHINE_READ] },
                            react_1.default.createElement(ShopProductMachineSelection_1.default, { selected: this.selectedMachineIds, onChange: (value) => {
                                    const index = this.selectedMachineIds.indexOf(value);
                                    if (index !== -1) {
                                        this.selectedMachineIds.splice(index, 1);
                                        return;
                                    }
                                    this.selectedMachineIds.push(value);
                                } }))) : null,
                        !this.categoryIsSoftware ? (react_1.default.createElement("p", { className: "znd-shop-product-page__product-number t-body " }, (0, translation_1.t)('product_page.product_number', { number: this.product.productNumber }))) : null,
                        this.renderSubscriptionOptions(),
                        this.renderAdditionalUser(),
                        react_1.default.createElement("div", { className: "d-flex flex-column flex-xl-row align-items-xl-start" }, !!this.product.extensions?.massiveDeferPriceDisplay?.defer ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "znd-loading-spinner--small mt-4" })) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "d-flex flex-column" },
                                this.renderPrice(),
                                this.renderBulkPrices({ className: 'd-xl-none' }),
                                this.renderProductQuantity()),
                            this.renderBulkPrices({ className: 'd-none d-xl-block' })))),
                        this.categoryIsSoftware ? (react_1.default.createElement("div", { className: "znd-shop-product-page__info-text t-body mt-5" }, (0, translation_1.t)('product_page.info_text'))) : null)),
                this.renderBottomSection()),
            this.renderCrossSellings()));
    }
    renderBottomSection() {
        if (this.categoryIsSoftware && !this.hasSoftwareFooterContent) {
            return null;
        }
        if (this.hasSoftwareFooterContent) {
            return (react_1.default.createElement("section", { className: (0, classnames_1.default)('znd-shop-product-page__bottom', 'divider-line') },
                this.customFields?.massiveSoftwareConfigurationDescription ? (react_1.default.createElement("div", { className: "znd-shop-product-page__content contain-description", dangerouslySetInnerHTML: {
                        __html: this.customFields?.massiveSoftwareConfigurationDescription,
                    } })) : null,
                this.customFields?.massiveSoftwareConfigurationUrlReadMore ? (react_1.default.createElement(Button_1.default, { className: "znd-shop-product-page__bottom-read-more", variant: ButtonVariant_1.default.text, text: (0, translation_1.t)('product.read_more'), iconRight: Zupicons_1.default.externalLink, onClick: () => {
                        window.open(this.customFields?.massiveSoftwareConfigurationUrlReadMore ?? undefined, '_blank');
                    } })) : null,
                this.customFields?.massiveSoftwareConfigurationCompareTable ? (react_1.default.createElement("div", { id: "znd-shop-product-page__table", className: "znd-shop-product-page__content" },
                    react_1.default.createElement("div", { className: "znd-shop-product-page__content-table", dangerouslySetInnerHTML: {
                            __html: this.customFields?.massiveSoftwareConfigurationCompareTable,
                        } }))) : null));
        }
        return (react_1.default.createElement("section", { className: (0, classnames_1.default)('znd-shop-product-page__bottom') },
            react_1.default.createElement("nav", { className: "znd-shop-product-page__tabs znd-tabs znd-tabs--center znd-tabs--small" },
                react_1.default.createElement("div", { className: "znd-tabs__item-wrapper" },
                    react_1.default.createElement("span", { className: "znd-tabs__item znd-tabs__item--active" }, (0, translation_1.t)('product_page.tabs.details')))),
            react_1.default.createElement("div", { className: "znd-shop-product-page__meta" },
                react_1.default.createElement("div", { className: "znd-shop-product-page__meta-group" },
                    react_1.default.createElement("p", { className: "znd-shop-product-page__meta-group-title" }, (0, translation_1.t)('product_page.specifications')),
                    this.renderSpecifications()),
                react_1.default.createElement("div", { className: "znd-shop-product-page__meta-group" },
                    react_1.default.createElement("p", { className: "znd-shop-product-page__meta-group-title" }, (0, translation_1.t)('product_page.applications')),
                    this.renderApplications()))));
    }
    renderAdditionalUser() {
        if (!(0, product_1.showPrices)(this.product) || !this.hasAdditionalSeat) {
            return false;
        }
        const max = this.additionalSeatProduct ? (0, product_1.getMaxPurchase)(this.additionalSeatProduct) : 0;
        return (react_1.default.createElement("div", { className: "znd-shop-product-page__additional-user" },
            react_1.default.createElement("div", { className: "znd-shop-product-page__additional-user-title mb-2 t-body-small font-weight-bold" }, (0, translation_1.t)('product_page.additional_user.title')),
            react_1.default.createElement(NumberStepper_1.default, { value: this.additionalUserQuantity, onChange: (quantity) => {
                    this.additionalUserQuantity = quantity ?? 0;
                }, min: 0, max: max })));
    }
    renderSubscriptionOptions() {
        if (!this.categoryIsSoftware || !ShopwareProducts_1.default.subscriptionOptionsConfigurator) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "znd-shop-product-page__subscription-options" },
            react_1.default.createElement("div", { className: "znd-shop-product-page__subscription-options-title d-flex mb-2 t-body-small font-weight-bold" },
                react_1.default.createElement("div", null, ShopwareProducts_1.default.subscriptionOptionsConfigurator.name),
                this.customFields?.massiveSoftwareConfigurationCompareTable ? (react_1.default.createElement("a", { href: "#znd-shop-product-page__table", className: "znd-shop-product-page__subscription-options-compare ml-3 d-flex flex-row align-items-center" },
                    react_1.default.createElement("span", null, (0, translation_1.t)('product_page.compare.title')),
                    react_1.default.createElement("i", { className: "icon-arrow-down ml-2" }))) : null),
            react_1.default.createElement("div", { className: "znd-shop-product-page__subscription-options-radios" }, ShopwareProducts_1.default.subscriptionOptions.map((option, key) => (react_1.default.createElement(Radio_1.default, { key: option.id, groupName: "propertyGroup", id: option.id, label: option.translated?.name ?? '', onChange: () => {
                    this.loading = true;
                    this.additionalSeatProduct = undefined;
                    this.cachedCrossSellingProducts.clear();
                    this.product = this.variants.find((product) => product.optionIds?.includes(option.id));
                    const seat = this.customFields?.massiveSoftwareConfigurationAdditionalSeatProduct;
                    Promise.all([
                        this.loadProductAdditionalSeatsProduct(seat),
                        this.loadProductCrossSellings(this.product?.id),
                    ]).finally(() => {
                        this.loading = false;
                    });
                }, isLarge: true, checked: this.checkedPropertyGroup(option.id, key) }))))));
    }
    renderPrice() {
        if (this.product && !(0, product_1.showPrices)(this.product)) {
            return null;
        }
        if (!this.categoryIsSoftware) {
            return (react_1.default.createElement("div", { className: "znd-shop-product-page__product-price t-headline-2" },
                this.priceProduct,
                react_1.default.createElement("br", null),
                react_1.default.createElement("span", { className: "znd-shop-product-page__product-price-info t-body-small" }, (0, translation_1.t)('product_page.price_without_tax_and_shipping'))));
        }
        if (this.loading || !this.product) {
            return (react_1.default.createElement("p", { className: "znd-shop-product-page__product-price t-headline-2" },
                react_1.default.createElement(LoadingSpinner_1.default, { className: 'mt-3' })));
        }
        return (react_1.default.createElement("div", { className: "znd-shop-product-page__product-price t-headline-2" },
            react_1.default.createElement("span", null, this.priceProduct),
            react_1.default.createElement(AddToCartButton_1.default, { buttonVariant: ButtonVariant_1.default.primary, className: "btn-block znd-shop-product-page__product-quantity-submit", productId: this.product.id, quantity: 1, additionalSeatsCount: this.additionalUserQuantity, buttonText: (0, translation_1.t)('product_page.buy_license.title'), disabled: this.disableAddToCartButton, machineIds: this.selectedMachineIds })));
    }
    renderProductQuantity() {
        if (this.categoryIsSoftware || !this.product) {
            return null;
        }
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-shop-product-page__product-quantity', {
                'mt-0': !(0, product_1.showPrices)(),
            }) },
            react_1.default.createElement("p", { className: "znd-shop-product-page__product-quantity-title t-body-small font-weight-bold" }, (0, translation_1.t)('product_page.choose_quantity')),
            (this.product?.purchaseSteps ?? 1) > 1 ? (react_1.default.createElement(NativeSelect_1.default, { placeholder: String(this.minQuantity), value: String(this.selectedQuantity), options: this.quantityOptions, alwaysShowPlaceholder: false, onChange: (value) => {
                    this.selectedQuantity = parseInt(value);
                } })) : (react_1.default.createElement("input", { type: "number", className: "form-control", value: this.selectedQuantity, onChange: (event) => {
                    const quantity = parseInt(event.target.value);
                    this.selectedQuantity = Math.max(this.minQuantity, Math.min(quantity, this.maxQuantity));
                }, min: this.minQuantity })),
            react_1.default.createElement(AddToCartButton_1.default, { buttonVariant: ButtonVariant_1.default.primary, className: "btn-block znd-shop-product-page__product-quantity-submit", productId: this.product.id, quantity: this.selectedQuantity })));
    }
    checkedPropertyGroup(optionId, key) {
        if (this.product?.optionIds !== null) {
            return this.product?.optionIds?.includes(optionId) ?? false;
        }
        return key === 0;
    }
    renderSpecifications() {
        const materials = this.product?.extensions?.massiveMaterials
            ?.slice()
            .sort((a, b) => a.translated?.name?.localeCompare(b.translated?.name ?? '') ?? 0) ?? [];
        const tools = this.product?.extensions?.massiveTools
            ?.slice()
            .sort((a, b) => a.technicalName.localeCompare(b.technicalName)) ?? [];
        const properties = this.product?.extensions?.massiveProperties
            ?.slice()
            .sort((a, b) => {
            const keyA = ((a.group?.translated?.position ?? '') + '').padStart(20, '0') +
                ((a.translated?.position ?? '') + '').padStart(20, '0');
            const keyB = ((b.group?.translated?.position ?? '') + '').padStart(20, '0') +
                ((b.translated?.position ?? '') + '').padStart(20, '0');
            return keyA.localeCompare(keyB, 'en'); // Always use "en" as it compares string numbers.
        }) ?? [];
        const topProperties = properties.filter(this.isTopProperty);
        const bottomProperties = properties.filter((option) => !this.isTopProperty(option));
        return (react_1.default.createElement("div", { className: "znd-shop-product-page__specifications" },
            this.renderProperties(topProperties),
            materials.length > 0 ? (react_1.default.createElement("div", { className: "znd-shop-product-page__specification" },
                react_1.default.createElement("p", { className: "znd-shop-product-page__specification-title" }, (0, translation_1.t)('product_page.recommended_materials')),
                react_1.default.createElement("p", { className: "znd-shop-product-page__specification-description" }, materials.map((material) => {
                    return (react_1.default.createElement("span", { key: material.id, className: "znd-shop-product-page__specification-description-line" }, material.translated?.name));
                })))) : null,
            tools.length > 0 ? (react_1.default.createElement("div", { className: "znd-shop-product-page__specification" },
                react_1.default.createElement("p", { className: "znd-shop-product-page__specification-title" }, (0, translation_1.t)('product_page.tools')),
                react_1.default.createElement("p", { className: "znd-shop-product-page__specification-description" }, tools.map((tool) => {
                    return (react_1.default.createElement("span", { key: tool.id, className: "znd-shop-product-page__specification-description-line" }, tool.technicalName));
                })))) : null,
            this.renderProperties(bottomProperties)));
    }
    isTopProperty(option) {
        return option.group?.extensions?.massivePropertyGroup?.externalId === PropertyGroupExternalIds_1.default.PROPERTIES;
    }
    renderProperties(properties) {
        return (react_1.default.createElement(react_1.default.Fragment, null, properties?.map((propertyGroupOption) => {
            return (react_1.default.createElement("div", { key: propertyGroupOption.id, className: "znd-shop-product-page__specification" },
                react_1.default.createElement("p", { className: "znd-shop-product-page__specification-title" }, propertyGroupOption.group?.translated?.name),
                react_1.default.createElement("p", { className: "znd-shop-product-page__specification-description" }, propertyGroupOption.translated?.name)));
        })));
    }
    renderApplications() {
        return (react_1.default.createElement("div", { className: "znd-shop-product-page__applications-wrapper" },
            react_1.default.createElement("div", { className: "znd-shop-product-page__applications" },
                (this.product?.extensions?.massiveApplications ?? []).map((application) => (react_1.default.createElement("div", { key: application.id, className: "znd-shop-product-page__application" },
                    react_1.default.createElement("div", { className: "znd-shop-product-page__application-image" }, application.media ? (react_1.default.createElement("img", { ...(0, media_1.imageSourceFromMedia)(application.media), alt: application.media.alt })) : null),
                    react_1.default.createElement("div", { className: "znd-shop-product-page__application-title" }, application.translated?.name)))),
                react_1.default.createElement("div", { className: "znd-shop-product-page__application-scroll-helper" }))));
    }
    renderCrossSellings() {
        const products = this.crossSellingProducts;
        if (products.length <= 0) {
            return null;
        }
        return (react_1.default.createElement("section", { className: "znd-shop-product-page__related-products" },
            react_1.default.createElement("h2", { className: "znd-shop-product-page__related-products-title" }, (0, translation_1.t)('product_page.related_products.title')),
            react_1.default.createElement("div", { className: "znd-shop-product-page__related-products-list" },
                products.map((product) => (react_1.default.createElement("div", { key: product.id, className: "znd-shop-product-page__related-products-item" },
                    react_1.default.createElement(ProductCardTile_1.default, { product: product })))),
                react_1.default.createElement("div", { className: "znd-shop-product-page__related-products-item-helper" }))));
    }
    loadProduct() {
        if (!this.productNumber) {
            (0, history_1.replaceHistory)(this.props.history, Paths_1.PATH_SHOP);
            return;
        }
        this.loading = true;
        this.product = undefined;
        this.additionalSeatProduct = undefined;
        this.cachedVariants.clear();
        this.cachedCrossSellingProducts.clear();
        ShopwareProducts_1.default.loadProductWithProductNumber(this.productNumber)
            .then((0, mobx_1.action)((product) => {
            this.product = product;
            this.selectedQuantity = (0, product_1.getMinPurchase)(this.product);
            const seat = this.customFields?.massiveSoftwareConfigurationAdditionalSeatProduct;
            return Promise.all([
                this.loadProductVariants(this.product),
                this.loadProductAdditionalSeatsProduct(seat),
                this.loadProductCrossSellings(this.product.id),
            ]);
        }))
            .catch(() => {
            if (!__DEV__) {
                (0, history_1.replaceHistory)(this.props.history, Paths_1.PATH_SHOP);
            }
        })
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
    loadProductVariants(product) {
        if (!product.parentId) {
            return Promise.resolve();
        }
        return ShopwareProducts_1.default.loadVariants(product).then((variants) => {
            variants?.forEach((variant) => {
                this.cachedVariants.set(variant.id, variant);
            });
        });
    }
    loadProductAdditionalSeatsProduct(productId) {
        if (!productId || !(0, product_1.showPrices)(this.product)) {
            return Promise.resolve();
        }
        return ShopwareProducts_1.default.loadProduct(productId).then((additionalSeatProduct) => {
            this.additionalSeatProduct = additionalSeatProduct;
        });
    }
    loadProductCrossSellings(productId) {
        if (!productId) {
            return Promise.resolve();
        }
        return ShopwareProducts_1.default.loadProductCrossSellingProductsMappings(productId).then((crossSellingProductsMappings) => {
            const crossSelling = (0, array_1.first)(crossSellingProductsMappings) ?? undefined;
            crossSelling?.products?.forEach((product) => {
                this.cachedCrossSellingProducts.set(product.id, product);
            });
        });
    }
    reloadProduct() {
        if (this.onRefreshDeferredPrices) {
            return;
        }
        this.onRefreshDeferredPrices = (0, mobx_1.reaction)(() => [UiStore_1.default.fiveSeconds], () => {
            if (this.loading) {
                return;
            }
            const pending = Array.from(this.cachedCrossSellingProducts.values())
                .filter((product) => product.extensions?.massiveDeferPriceDisplay?.defer ?? false)
                .map((product) => product.id)
                .concat(Array.from(this.cachedVariants.values())
                .filter((product) => product.extensions?.massiveDeferPriceDisplay?.defer ?? false)
                .map((product) => product.id));
            if (!!this.product?.extensions?.massiveDeferPriceDisplay?.defer) {
                pending.push(this.product.id);
            }
            if (!!this.additionalSeatProduct?.extensions?.massiveDeferPriceDisplay?.defer) {
                pending.push(this.additionalSeatProduct.id);
            }
            if (pending.length <= 0) {
                return;
            }
            ShopwareProducts_1.default.loadProducts(pending).then((products) => {
                products?.forEach((product) => {
                    if (this.product?.id === product.id) {
                        this.product = product;
                    }
                    if (this.additionalSeatProduct?.id === product.id) {
                        this.additionalSeatProduct = product;
                    }
                    if (this.cachedCrossSellingProducts.has(product.id)) {
                        this.cachedCrossSellingProducts.set(product.id, product);
                    }
                    if (this.cachedVariants.has(product.id)) {
                        this.cachedVariants.set(product.id, product);
                    }
                });
            });
        });
    }
    renderBulkPrices(props) {
        if (!(0, product_1.showBulkPrices)(this.categoryIsSoftware, this.product)) {
            return null;
        }
        const calculatedPrices = this.product?.calculatedPrices ?? [];
        const currency = this.product?.extensions?.zkpProductData?.currencyIsoCode;
        if (!currency) {
            return null;
        }
        const tableData = calculatedPrices
            .slice()
            .sort((a, b) => (a.quantity ?? 0) - (b.quantity ?? 0))
            .map((calculatedPrice, index, prices) => {
            if (index === prices.length - 1) {
                return {
                    quantity: (0, translation_1.t)('product_page.bulk_prices.quantity_from', { from: calculatedPrice.quantity }),
                    price: (0, money_1.moneyFormat)(calculatedPrice.unitPrice ?? 0, currency),
                };
            }
            return {
                quantity: (0, translation_1.t)('product_page.bulk_prices.quantity_from_to', {
                    from: index === 0 ? 1 : (prices[index - 1].quantity ?? 0) + 1,
                    to: calculatedPrice.quantity,
                }),
                price: (0, money_1.moneyFormat)(calculatedPrice.unitPrice ?? 0, currency),
            };
        });
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-shop-product-page__bulk-price-wrapper', props.className) },
            react_1.default.createElement("table", { className: "znd-shop-product-page__bulk-price" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", { className: "znd-shop-product-page__bulk-price-title" },
                        react_1.default.createElement("th", { className: "znd-shop-product-page__bulk-price-cell znd-shop-product-page__bulk-price-cell--quantity" }, (0, translation_1.t)('product_page.bulk_prices.quantity_title')),
                        react_1.default.createElement("th", { className: "znd-shop-product-page__bulk-price-cell znd-shop-product-page__bulk-price-cell--price" }, (0, translation_1.t)('product_page.bulk_prices.price_per_item_title')))),
                react_1.default.createElement("tbody", null, tableData.map((info) => (react_1.default.createElement("tr", { key: info.quantity, className: "znd-shop-product-page__bulk-price-row" },
                    react_1.default.createElement("td", { className: "znd-shop-product-page__bulk-price-cell znd-shop-product-page__bulk-price-cell--quantity" }, info.quantity),
                    react_1.default.createElement("td", { className: "znd-shop-product-page__bulk-price-cell znd-shop-product-page__bulk-price-cell--price" }, info.price))))))));
    }
    isCategorySoftware(category) {
        return Categories_1.default.SOFTWARE === category?.extensions?.massiveCategory?.externalId;
    }
}
__decorate([
    bind_decorator_1.default
], ShopProduct.prototype, "isTopProperty", null);
__decorate([
    bind_decorator_1.default
], ShopProduct.prototype, "renderProperties", null);
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(ShopProduct));
